import { Semver } from './misc/semver.js';
export const VERSION = new Semver('2.0.3');
